class UserApi {
    constructor(fetchService) {
        this.fetchService = fetchService;
    }
    getCurrentUser() {
        return this.fetchService.get('/users/current');
    }
}
export default UserApi;
